export const PUBLIC_RENTAL_FORM = 'PublicRentalForm'
export const RENTING_LIST = 'RentingList'
export const INTERESTED_PERSON_DETAILS = 'InterestedPersonDetails'
